import React                from 'react';
import { InfoWindow }       from "react-google-maps";
import LoadingSvg           from '../LoadingSvg';
import FontIcon             from 'material-ui/FontIcon';
import PlaceItem            from './../../components/PlaceItem';
import Avatar               from 'material-ui/Avatar';
import { displayDistance }  from './../../classes/Distance';

/**
 * This component gets the place item from state.map.place rather as prop passed to the component.
 *
 * When the user changes location, the places on the parent map are not update to prevent the map from
 * re-rendering and refreshing.  To access an up to date place (with accurate distance), the place subject
 * to the open window is stored in state.
 */

class PlaceMarkerInfo extends PlaceItem
{
    gotToPlace = (callBack) => {
        this.props.closeWindow();
        callBack(this.props.map.place);
    };

    isTrail = () =>
    {
        return (this.props.map.place.type === 'trail');
    };

    getDirectionsCallBack = () =>
    {
        let callBack;
        if (this.props.directions !== null && (this.props.directions.show && this.props.map.place.id === this.props.directions.place.id))
        {
            callBack = this.props.resetDirections;
        }
        else
        {
            callBack = this.props.showDirections.bind(this, this.props.map.place);
        }

        return callBack;
    };

    renderGoogleLink = () =>
    {
        if (null !== this.props.geo.coords) {
            let link = 'https://www.google.co.uk/maps/dir/' + this.props.geo.coords.latitude + ',' + this.props.geo.coords.longitude + '/' + this.props.map.place.coords.lat + ',' + this.props.map.place.coords.long;
            return (
                <a href={ link } target="_blank" rel="noopener noreferrer">Google Maps</a>
            );
        }
        return null;
    };

    renderDirectionsIcon = () =>
    {
        let directionsIcon;

        if (null !== this.props.geo.coords && this.props.directions !== null)
        {
            let callBack = this.getDirectionsCallBack();
            directionsIcon = (
                <span>
                    { 'Get directions ' }
                    <span
                        className="tap-event link-text"
                        onTouchTap={ callBack }>
                            { 'in this app' }
                        </span>
                    { ' or with ' }
                    { this.renderGoogleLink() }
                </span>
            );
        }
        else
        {
            directionsIcon = 'Turn on location services to see directions.'
        }

        return (
            <div>
                <p className="iw-text">
                    <FontIcon className="material-icons">directions</FontIcon>
                </p>
                <p className="iw-text" style={ { marginLeft: 10 } }>
                    { directionsIcon }
                </p>
            </div>
        );
    };

    resolveImage = () =>
    {
        let { place } = this.props.map;

        if (place.icon.length > 0)
        {
            return place.icon;
        }
        else if (this.isTrail())
        {
            return place.image;
        }
        else
        {
            return place.images[0].url;
        }
    };

    renderText = () =>
    {
        let { place } = this.props.map;
        if (this.isTrail())
        {
            return place.summary;
        }
        else
        {
            return place.intro;
        }
    };

    render = () =>
    {
        if (typeof this.props.map === 'undefined' || null === this.props.map || null === this.props.map.place)
        {
            return (
                <div className="place-container">
                    <LoadingSvg />
                </div>
            );
        }

        let clickEvent;

        if ('trail' === this.props.map.place.type)
        {
            clickEvent = this.onTrailSelected;
        }
        else
        {
            clickEvent = this.onPlaceSelected;
        }

        let distance;
        if (this.props.map.place.distance)
        {
            distance = displayDistance(this.props.map.place.distance, '');
        }

        return (
            <InfoWindow
                maxWidth={ 200 }
                title="Places & Trails"
                onCloseClick={ this.props.closeWindow }
            >
                <div>
                <div className="iw">
                    <h3
                        className="iw-h3 tap-event"
                        onTouchTap={ this.gotToPlace.bind(this, clickEvent) }
                    >{ this.props.map.place.name }<span>{ distance }</span></h3>
                    <div className="iw-info">
                        <Avatar
                            style={ { float: "left", margin: "0 14px 4px 0px", height: 110, width: 110, objectFit: 'cover' } }
                            onTouchTap={ this.gotToPlace.bind(this, clickEvent) }
                            className="tap-event"
                            src={ this.resolveImage() }
                        />
                        { this.renderText() + ' ' }
                        <span
                            className="tap-event link-text"
                            style={ { textDecoration: 'underline' } }
                            onTouchTap={ this.gotToPlace.bind(this, clickEvent) }
                        >More...</span>
                    </div>
                </div>
                    <div className="iw">
                        { this.renderDirectionsIcon() }
                    </div>
                </div>
            </InfoWindow>
        );
    }

}

export default PlaceMarkerInfo;



// WEBPACK FOOTER //
// ./src/components/Map/PlaceMarkerInfo.js